<div class="border">
  <form [formGroup]="uploadForm">
    <div class=" border bg-body-tertiary">
      <div class=" p-2 px-4 border-bottom">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start gap-2">
          <div >
            <div class="d-flex align-items-center gap-1 mb-1">
              <span class="badge bg-primary rounded-pill" style="width:6px;height:14px;padding:0;"></span>
              <h3 class="mb-0 fw-semibold text-primary"> <i class="pi pi-file-pdf me-1"></i>  {{title}}</h3>
            </div>
            <span *ngIf="isEditable" class=" fw-semibold mb-1 small">Select Number of Documents(Optional) </span>
            <!-- <d class="text-muted small mb-1">Enter total number of document rows.</div> -->
            <div *ngIf="isEditable" class="d-inline-flex align-items-center border rounded-pill px-2 py-0 bg-light">
              <button type="button" class="btn btn-outline-secondary btn-sm py-0" (click)="decrementCount()">–</button>
              <span class="px-2 fw-semibold small">{{ fileCount }}</span>
              <button type="button" class="btn btn-outline-secondary btn-sm py-0" (click)="incrementCount()">+</button>
            </div>
          </div>
          <div>
           
          </div>
          <div class="d-flex flex-column align-items-md-end gap-1">
            <div class="text-secondary small mb-0">Total Count: <span class="fw-semibold text-primary">{{ fileCount }}</span></div>
            <!-- <button type="button" class="btn btn-primary btn-sm py-1 px-2" *ngIf="selectedRow?.length > 0" (click)="finalizeDocuments.emit(selectedRow)">
              <i class="pi pi-check-circle me-1 small"></i> Finalize
            </button> -->
          </div>
        </div>
      </div>
    </div>
      
    <div *ngIf="fileCount > 0" class="table-responsive" formArrayName="documents">
      <p-table #dt [value]="documentsArray.controls" responsiveLayout="scroll" [paginator]="documentsArray.controls.length > 9" [rows]="10" [(selection)]="selectedRow" [selectionMode]="'single'" [metaKeySelection]="false" [rowsPerPageOptions]="[5, 10]" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['name', 'description', 'type', 'date']" [tableStyle]="{ 'min-width': '100%' }">
        <ng-template pTemplate="header">
          <tr class="align-middle">
            <th *ngIf="isEditable " class="text-center small text-muted">ACTIONS</th>
            <th *ngIf="isFinalizeVisible" class="text-center"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
            <th class="text-center small text-muted">S.NO.</th>
            <th pSortableColumn="name" class="small">
              <div class="d-flex gap-1">
                <div class="d-flex align-items-center gap-2">NAME OF DOCUMENT</div>
                <p-columnFilter class="text-gray-600" field="name" display="menu" type="text"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="description" class="small">
              <div class="d-flex gap-1">
                <div class="d-flex align-items-center gap-2">BRIEF DESCRIPTION</div>
                <p-columnFilter class="text-gray-600" field="description" display="menu" type="text"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="type" class="small">
              <div class="d-flex gap-1">
                <div class="d-flex align-items-center gap-2">TYPE OF DOCUMENT</div>
                <p-columnFilter class="text-gray-600" field="type" display="menu" type="text"></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="date" class="small">
              <div class="d-flex gap-1">
                <div class="d-flex align-items-center gap-2">DATE OF UPLOAD</div>
                <p-columnFilter class="text-gray-600" field="date" display="menu" type="date"></p-columnFilter>
              </div>
            </th>
            <th *ngIf="isEditable" class="text-center small text-muted">UPLOAD DOCUMENT</th>
            <th class="text-center small text-muted">DOWNLOAD DOCUMENT</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr [formGroup]="row" class="align-middle">
            <td *ngIf="isEditable " class="text-center">
              <div *ngIf="row.get('id')?.value; else showUpload" class="d-flex justify-content-center gap-2">
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="editDocument(rowIndex)"><i class="pi" [ngClass]="{'pi-save': editModeIndex === rowIndex, 'pi-pencil': editModeIndex !== rowIndex}"></i></button>
                <button  type="button" class="btn btn-outline-danger btn-sm" (click)="deleteDocument(rowIndex)"><i class="pi pi-trash"></i></button>
              </div>
              <ng-template #showUpload>
                <button *ngIf="!row.get('id')?.value && !isSaveVied" type="button" class="btn btn-outline-success btn-sm" (click)="saveDocument(rowIndex)"><i class="pi pi-check-circle me-1"></i> Upload</button>
              </ng-template>
            </td>
            <td *ngIf="isFinalizeVisible" class="text-center"><p-tableCheckbox [value]="row" selectionMode="multiple"></p-tableCheckbox></td>
            <td class="text-center">{{ rowIndex + 1 }}</td>
            <td><input type="text" class="form-control form-control-sm" formControlName="name" [readonly]="isMandatoryDocName(row.get('name')?.value)" /></td>
            <td><textarea rows="2" class="form-control form-control-sm w-48" formControlName="description" placeholder="Enter brief description..."></textarea></td>
            <td>
              <select class="form-select form-select-sm" formControlName="type">
                <option value="" disabled selected>Select Doc Type</option>
                <option *ngFor="let doc of documentTypes" [value]="doc.label">{{ doc.value }}</option>
              </select>
            </td>
            <td><input type="date" class="form-control form-control-sm" formControlName="date" /></td>
            <td *ngIf="isEditable" class="text-center">
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="fileInput.click()"><i class="pi pi-cloud-upload"></i></button>
              <input type="file" #fileInput class="d-none" (change)="onFileSelect($event, rowIndex)" accept="{{ row.get('type')?.value }}" />
              <div *ngIf="row.get('file')?.value" class="small text-muted mt-1 text-truncate">{{ row.get('file')?.value?.name }}</div>
            </td>
            <td class="text-center">
              <!-- <button *ngIf="row.get('file')?.value" type="button" class="btn btn-primary btn-sm" (click)="downloadDocument(row)"><i class="pi pi-download"></i></button> -->
              <a *ngIf="row.get('file')?.value" type="button" class="btn btn-primary btn-sm" href="{{ baseUrl + row.get('file')?.value }}" target="_blank" ><i class="pi pi-download"></i></a>
              <span *ngIf="!row.get('file')?.value" class="text-muted small">—</span>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10" class="text-center text-muted py-3">No records found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </form>
</div>
